import { OrganizationType } from '~/db_types';
export const OrganizationTypeDisplay = new Map([
    [OrganizationType.CONTRACTOR, 'Contractor'],
    [OrganizationType.GOVERNMENT, 'Government'],
    [OrganizationType.MANUFACTURER, 'Manufacturer'],
    [OrganizationType.PROCESSOR, 'Processor'],
    [OrganizationType.SUPPLIER, 'Supplier'],
    [OrganizationType.VENDOR, 'Vendor']
]);
